(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lisa-fragrance-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const popup = document.getElementById('lisa-fragrance-popup');
    if (!popup) return;
    const key = 'lisa-fragrance-coupon-dismissed-v2';
    if (document.getElementById('LisaGiftCouponConfig')?.dataset.hasGift === 'true') return;
    try { if (sessionStorage.getItem(key) === '1') return; } catch {}
    let dismissed = false;
    let showTimer;
    let previousFocus;
    let applying = false;
    const closeButton = popup.querySelector('.lisa-fragrance-popup__close');
    const chooseLink = popup.querySelector('.lisa-fragrance-popup__link');
    const status = popup.querySelector('.lisa-fragrance-popup__status');
    const rememberDismissal = () => {
      dismissed = true;
      window.clearTimeout(showTimer);
      try { sessionStorage.setItem(key, '1'); } catch {}
    };
    const dismiss = () => {
      if (dismissed) return;
      rememberDismissal();
      if (popup.contains(document.activeElement)) {
        const target = previousFocus && previousFocus !== document.body && previousFocus.isConnected
          ? previousFocus : document.querySelector('#MainContent a[href], #MainContent button');
        target?.focus({ preventScroll: true });
      }
      if (popup.hidden || window.matchMedia('(prefers-reduced-motion: reduce)').matches || typeof popup.animate !== 'function') {
        popup.hidden = true;
        return;
      }
      popup.style.pointerEvents = 'none';
      const current = window.getComputedStyle(popup);
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const exit = popup.animate([
        { opacity: current.opacity, transform: current.transform },
        { opacity: 0, transform: mobile ? 'translate(-50%, 10px)' : 'translateY(10px)' }
      ], { duration: 180, easing: 'cubic-bezier(.4, 0, 1, 1)', fill: 'forwards' });
      const finish = () => { popup.hidden = true; };
      exit.addEventListener('finish', finish, { once: true });
      window.setTimeout(finish, 220);
    };
    const applyAndDismiss = async (trigger, destination) => {
      if (dismissed || applying) return;
      applying = true;
      closeButton.disabled = true;
      chooseLink.setAttribute('aria-disabled', 'true');
      popup.setAttribute('aria-busy', 'true');
      status.hidden = false;
      status.textContent = popup.dataset.applying;
      try {
        if (!window.LisaGiftCoupon?.apply) throw new Error();
        await window.LisaGiftCoupon.apply();
      } catch {
        applying = false;
        closeButton.disabled = false;
        chooseLink.removeAttribute('aria-disabled');
        popup.removeAttribute('aria-busy');
        status.textContent = popup.dataset.applyError;
        return;
      }
      popup.removeAttribute('aria-busy');
      document.dispatchEvent(new CustomEvent('lisa:gift-dismissed', { detail: { trigger } }));
      dismiss();
      if (destination) {
        const delay = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 1500;
        window.setTimeout(() => { window.location.assign(destination); }, delay);
      }
    };
    closeButton.addEventListener('click', () => applyAndDismiss(closeButton));
    chooseLink.addEventListener('click', event => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      applyAndDismiss(chooseLink, chooseLink.href);
    });
    popup.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        event.preventDefault();
        applyAndDismiss(closeButton);
      }
    });
    showTimer = window.setTimeout(() => {
      if (!dismissed) {
        previousFocus = document.activeElement;
        popup.hidden = false;
      }
    }, 1500);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lisa-google-review-badge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lisa-google-review-badge')) {
    customElements.define('lisa-google-review-badge', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        const details = this.querySelector('details');
        const summary = this.querySelector('summary');
        const close = () => { details.open = false; summary.focus(); };
        this.querySelector('button').addEventListener('click', close, { signal });
        document.addEventListener('pointerdown', event => {
          if (details.open && !this.contains(event.target)) details.open = false;
        }, { signal });
        document.addEventListener('keydown', event => {
          if (event.key === 'Escape' && details.open) { event.preventDefault(); close(); }
        }, { signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lisa-satisfaction-guarantee"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lisa-satisfaction-guarantee')) {
    customElements.define('lisa-satisfaction-guarantee', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.details = this.querySelector('details');
        this.trigger = this.querySelector('summary');
        if (!this.details || !this.trigger) return;
        this.pinned = false;
        this.hovering = false;
        this.trigger.addEventListener('click', event => {
          event.preventDefault();
          if (this.pinned) this.close();
          else { this.pinned = true; this.open(); }
        }, { signal });
        this.addEventListener('pointerenter', event => {
          if (event.pointerType === 'touch' || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
          this.hovering = true;
          clearTimeout(this.closeTimer);
          this.open();
        }, { signal });
        this.addEventListener('pointerleave', () => {
          this.hovering = false;
          this.closeTimer = setTimeout(() => {
            if (!this.pinned && !this.contains(document.activeElement)) this.close();
          }, 180);
        }, { signal });
        this.addEventListener('focusout', event => {
          if (!this.contains(event.relatedTarget) && !this.hovering) this.close();
        }, { signal });
        this.querySelector('.lisa-guarantee__close').addEventListener('click', () => this.close(true), { signal });
        this.details.addEventListener('toggle', () => {
          this.trigger.setAttribute('aria-expanded', String(this.details.open));
        }, { signal });
        document.addEventListener('pointerdown', event => {
          if (this.details.open && !this.contains(event.target)) this.close();
        }, { signal });
        document.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this.details.open) {
            const restoreFocus = this.contains(document.activeElement);
            this.close(restoreFocus);
          }
        }, { signal });
      }
      open() {
        clearTimeout(this.closeTimer);
        this.details.open = true;
        this.trigger.setAttribute('aria-expanded', 'true');
      }
      close(restoreFocus = false) {
        clearTimeout(this.closeTimer);
        this.pinned = false;
        this.details.open = false;
        this.trigger.setAttribute('aria-expanded', 'false');
        if (restoreFocus) this.trigger.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.closeTimer);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lisa-scent-notes"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lisa-scent-notes')) {
    customElements.define('lisa-scent-notes', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.lisa-scents__track');
        this.list = this.querySelector('.lisa-scents__list');
        this.controls = this.querySelector('.lisa-scents__controls');
        this.prev = this.querySelector('[data-scent-prev]');
        this.next = this.querySelector('[data-scent-next]');
        this.hint = this.querySelector('.lisa-scents__hint');
        this.abort = new AbortController();
        const options = { signal:this.abort.signal };
        const update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const position = Math.abs(this.track.scrollLeft);
          this.controls.hidden = max < 3;
          this.hint.hidden = max < 3;
          this.prev.disabled = position < 3;
          this.next.disabled = position >= max - 3;
        };
        const move = (direction) => {
          const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
          const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollBy({left:direction * rtl * this.track.clientWidth * .8,behavior:reduced?'instant':'smooth'});
        };
        this.prev.addEventListener('click',()=>move(-1),options);
        this.next.addEventListener('click',()=>move(1),options);
        this.track.addEventListener('scroll',update,{...options,passive:true});
        this.track.addEventListener('keydown',(event)=>{
          if(event.target !== this.track)return;
          if(event.key==='ArrowRight'||event.key==='ArrowLeft'){
            event.preventDefault();
            const rtl=getComputedStyle(this.track).direction==='rtl';
            move((event.key==='ArrowRight'?1:-1)*(rtl?-1:1));
          }
        },options);
        this.observer = new ResizeObserver(update);
        this.observer.observe(this.track);
        this.observer.observe(this.list);
        update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lisa-video-cover"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lisa-video-cover')) {
  const frameCache = new Map();
  let captureQueue = Promise.resolve();

  const captureFrame = (source) => new Promise((resolve) => {
    const video = document.createElement('video');
    video.crossOrigin = 'anonymous';
    video.muted = true;
    video.playsInline = true;
    video.preload = 'auto';
    let finished = false;
    let target = null;

    const finish = (frame) => {
      if (finished) return;
      finished = true;
      clearTimeout(timeout);
      video.removeAttribute('src');
      video.load();
      resolve(frame);
    };

    const draw = () => {
      if (finished || target === null || video.seeking || video.readyState < 2) return;
      if (Math.abs(video.currentTime - target) > 0.1) return;
      try {
        const canvas = document.createElement('canvas');
        const scale = Math.min(1, 960 / Math.max(video.videoWidth, video.videoHeight));
        canvas.width = Math.max(1, Math.round(video.videoWidth * scale));
        canvas.height = Math.max(1, Math.round(video.videoHeight * scale));
        const context = canvas.getContext('2d');
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        finish(canvas.toDataURL('image/jpeg', 0.85));
      } catch {
        finish(null);
      }
    };

    const timeout = setTimeout(() => finish(null), 15000);
    video.addEventListener('error', () => finish(null), { once: true });
    video.addEventListener('loadedmetadata', () => {
      if (finished) return;
      if (!Number.isFinite(video.duration) || video.duration <= 0) return finish(null);
      target = Math.min(1, video.duration / 2);
      video.currentTime = target;
    }, { once: true });
    video.addEventListener('seeked', draw);
    video.addEventListener('loadeddata', draw);
    video.src = source;
    video.load();
  });

  customElements.define('lisa-video-cover', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready || !this.dataset.source) return;
      if (!('IntersectionObserver' in window)) {
        this.loadFrame();
        return;
      }
      this.observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.observer.disconnect();
        this.loadFrame();
      }, { rootMargin: '200px' });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    async loadFrame() {
      const source = this.dataset.source;
      if (!frameCache.has(source)) {
        const pending = captureQueue.then(() => captureFrame(source));
        frameCache.set(source, pending);
        captureQueue = pending.catch(() => null);
      }
      const frame = await frameCache.get(source);
      const image = this.querySelector('img');
      if (!frame || !image || !this.isConnected) return;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = frame;
      this.dataset.ready = 'true';
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lisa-watch-product-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lisa-watch-product-video')) {
  customElements.define('lisa-watch-product-video', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.querySelector('button').addEventListener('click', (event) => {
        event.stopPropagation();
        const gallery = this.closest('media-gallery');
        const target = gallery?.querySelector(`[id^="Slide-"][data-media-id="${this.dataset.videoId}"]`);
        if (!target || typeof gallery.setActiveMedia !== 'function') return;
        target.classList.add('lisa-video-selected');
        gallery.setActiveMedia(this.dataset.videoId, false, {
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
          block: window.matchMedia('(min-width: 750px)').matches ? 'center' : 'nearest',
          inline: 'start'
        });
        const player = target.querySelector('deferred-media > video, deferred-media > iframe');
        if (!player) return;
        player.focus({ preventScroll: true });
        if (player.tagName === 'VIDEO') {
          player.playsInline = true;
          player.play().catch(() => {});
        } else {
          const origin = new URL(player.src).origin;
          if (player.classList.contains('js-youtube')) {
            player.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'playVideo', args: [] }), origin);
          } else if (player.classList.contains('js-vimeo')) {
            player.contentWindow.postMessage(JSON.stringify({ method: 'play' }), origin);
          }
        }
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
